import React from 'react';
import { observer } from 'mobx-react';
import { Trans, useTranslation } from 'react-i18next';
import { VideoPlayer } from '../../subject/video-player-decisions';
import { Heading1 } from '../../design-system/headings';
import PresentationHeading from './presentation-heading';

export const Video = observer(
    ({
        ui,
        videoTokenRequested,
        videoPlayerUrl,
        token,
        playerPresetCaptionsLanguage,
        playerCaptionsSettings,
        canFastForward,
    }) => {
        const { t } = useTranslation('assessment');

        const logEvent = (subject, event_id, context, options) => {};

        return (
            <div className="assessment-presentation">
                <div className="question">
                    <PresentationHeading ui={ui} />
                    {ui.subject ? (
                        <VideoPlayer
                            videoTokenRequested={videoTokenRequested}
                            token={token && token.token}
                            videoPlayerUrl={videoPlayerUrl}
                            subject={ui.subject}
                            logEvent={logEvent}
                            presetCaptionsLanguage={
                                playerPresetCaptionsLanguage
                            }
                            captionsSettings={playerCaptionsSettings}
                            canFastForward={canFastForward}
                        />
                    ) : (
                        <p>Failed to load player, no subject supplied</p>
                    )}
                </div>
            </div>
        );
    }
);
